function English() {
  return <h1>English</h1>;
}

export default English;